import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryQuickLinks from '@/pages/home/components/CategoryQuickLinks';
import MovieRecommendations from '@/pages/home/components/MovieRecommendations';
import NewsHighlights from '@/pages/home/components/NewsHighlights';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroCarousel />
        <CategoryQuickLinks />
        <MovieRecommendations />
        <NewsHighlights />
      </main>
      <Footer />
    </div>
  );
}